/**
 * Resolução de âncoras do tour, isolada da camada de UI.
 *
 * Fica em módulo próprio para poder ser testada sem arrastar MUI e Iconify
 * para dentro do teste — e porque é aqui que mora a regra que mais importa em
 * produção: passo sem elemento na tela é passo que não existe.
 */
export function findAnchor(anchor) {
  if (!anchor || typeof document === 'undefined') return null;

  return document.querySelector(`[data-tour="${anchor}"]`);
}

/**
 * Descarta os passos cujo elemento não está renderizado.
 *
 * É o que mantém o tour honesto no mobile, onde o alternador de visualização
 * não é renderizado, e em qualquer aba que não seja a de produtos.
 */
export function resolveSteps(steps) {
  return steps.filter((step) => !step.anchor || Boolean(findAnchor(step.anchor)));
}

